/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import Frames from './Frames';
import WallColor from './WallColor';
import RoomView from './RoomView';
import FramePopUp from '../Components/Modal/FramePopUp';
import MediaQuery from 'react-responsive';
import Stretching from './Stretching';
import Hanging from './Hanging';
import Wrapping from './Wrapping';

class Tabs extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.removeFrame = this.removeFrame.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(key) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedTab: key
      }
    })
  }

  removeFrame() {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
        selectedFrame: [],
        canvasFrameTotal: 0
			}
		})
	}

  render() {
    return (
      <div className="attr_sect full_width">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <Tab.Container className="tab_1" activeKey={this.props.selectedTab} defaultActiveKey="stretching" id="tab-container-frame" onSelect={this.handleSelect}>
                <div className="tabbable-panel">
                  <div className="tabbable-line">
                    <Nav bsStyle="tabs">
                      <NavItem eventKey="stretching">Stretching</NavItem>
                      <NavItem eventKey="wrapping">Wrapping</NavItem>
                      <NavItem eventKey="hanging">Hanging</NavItem>
                      <NavItem eventKey="frames">Frames</NavItem>
                      <NavItem eventKey="wallcolor">Wall Colour</NavItem>
                      <NavItem eventKey="roomview">Room View</NavItem>
                    </Nav>
                    <MediaQuery minDeviceWidth={768}>
                      {this.props.selectedFrame.size > 0 ?
                        <div className="sel_img">
                          <p>
                            <a href="#!" onClick={this.removeFrame} className="btn btn-danger text-upper right" style={{marginLeft: '5px'}}>Remove Frame</a>
                            <a href="#!" className="right" onClick={this.handleShow}>Currently Selected <i><img src={this.props.selectedFrame.getIn(['images', 0, 'src'])} alt={this.props.selectedFrame.get('name')} /></i></a>
                          </p>
                          <FramePopUp {...this.props} show={this.state.show} onHide={this.handleClose} />
                        </div>
                        : ''
                      }
                    </MediaQuery>
                    <div className="tab-content">
                      <div className="tab-pane active">
                        <div className="in_tabs">
                          <div className="tab-content">
                            <div className="tab-pane active tb_cont" id="all">
                              <Tab.Content>
                                <Tab.Pane eventKey="stretching">
                                  <Stretching {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="wrapping">
                                  <Wrapping {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="hanging">
                                  <Hanging {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="frames">
                                  <Frames {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="wallcolor">
                                  <WallColor {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="roomview">
                                  <RoomView {...this.props} />
                                </Tab.Pane>
                              </Tab.Content>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Tabs;